module.exports = __webpack_public_path__ + "static/media/card-boosters-bg_mobile_dark.a56ab4cb.svg";